import { render, staticRenderFns } from "./MappingItem.vue?vue&type=template&id=754019dc"
import script from "./MappingItem.vue?vue&type=script&lang=js"
export * from "./MappingItem.vue?vue&type=script&lang=js"
import style0 from "./MappingItem.vue?vue&type=style&index=0&id=754019dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports